import { Component, OnInit, Inject } from '@angular/core';
import { SLOW_FADE_IN } from '../../util/animations/animation';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Auth0Service } from '../../authentication/auth0/auth0.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-queue-filter',
  templateUrl: './queue-filter.component.html',
  styleUrls: ['./queue-filter.component.scss'],
  animations: [SLOW_FADE_IN]
})
export class QueueFilterComponent implements OnInit {
  board:any;
  queues = [];
  allItemSelected = false;
  userId;

  constructor(public dialogRef: MatDialogRef<QueueFilterComponent>,
    @Inject(MAT_DIALOG_DATA) public popup,
    private auth0: Auth0Service) {
      this.userId = this.auth0.idTokenDetail[`${environment.auth0Config.audience}practitioner_id`];
    }
  
  ngOnInit(){
    this.board = this.popup.board;
    this.queues = this.popup.queues;
    this.onSelectAllItems();
  }

  onSelectAllItems(event?){
    if(event)
      this.queues.map(x=> { x.hidden = !event.checked});

    const hiddenQueues = this.queues.filter(x=> x.hidden);
    this.allItemSelected = !hiddenQueues.length;
    this.setFilter(hiddenQueues);
  }

  onQueueChecked(item, i) {
    this.queues[i].hidden = !item.hidden;
    this.onSelectAllItems();
  }

  setFilter(queues) {
    const queueIds = queues.map(x=> { if(x.hidden) return x.id});
    if (this.board) {
      let allFilters = JSON.parse(localStorage.getItem('queue-filters'));
      const oldFiltersOfUser = allFilters&&allFilters[this.userId];
      const newFilterOfUser = {
        [this.userId]: {
          ...oldFiltersOfUser,
          [this.board.id]: queueIds
        }
      }
      allFilters = {
        ...allFilters,
        ...newFilterOfUser
      }
      localStorage.setItem('queue-filters', JSON.stringify(allFilters));
    }
  }

  onClose(){
    this.dialogRef.close();
  }
}
